// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__UfZ29","description":"MealItem_description__+0qYa","price":"MealItem_price__3aaxA"};